import axios from "axios";
import { createApiError } from "./errorUtils";

const API_URL = process.env.REACT_APP_API_URL;

// Cadastro de usuário
export function cadastrarUsuario(user) {
  return axios.post(`${API_URL}/user`, user).catch((error) => {
    throw createApiError(error, "Erro ao se comunicar com o servidor.");
  });
}

// Busca informações do usuário
export function getUser() {
  return axios.get(`${API_URL}/user`).catch((error) => {
    throw createApiError(error, "Erro ao obter informações do usuário.");
  });
}

// Altera a senha do usuário
export function alterarSenha(senhaAtual, novaSenha) {
  return axios.put(`${API_URL}/user/senha`, { senhaAtual, novaSenha }).catch((error) => {
    throw createApiError(error, "Erro ao se comunicar com o servidor.");
  });
}

export function getLoja() {
  return axios.get(`${API_URL}/lojas`).catch((error) => {
    throw createApiError(error, "Erro ao obter informações da loja.");
  });
}

export function getLojaLinks({ includeInactive = false } = {}) {
  return axios
    .get(`${API_URL}/lojas/links`, {
      params: includeInactive ? { includeInactive: "true" } : undefined,
    })
    .then((response) => response.data)
    .catch((error) => {
      throw createApiError(error, "Erro ao obter os links da loja.");
    });
}

export function criarLojaLink(payload) {
  return axios
    .post(`${API_URL}/lojas/links`, payload)
    .then((response) => response.data)
    .catch((error) => {
      throw createApiError(error, "Erro ao criar link da loja.");
    });
}

export function atualizarLojaLink(linkId, payload) {
  return axios
    .put(`${API_URL}/lojas/links/${linkId}`, payload)
    .then((response) => response.data)
    .catch((error) => {
      throw createApiError(error, "Erro ao atualizar link da loja.");
    });
}

export function deletarLojaLink(linkId) {
  return axios
    .delete(`${API_URL}/lojas/links/${linkId}`)
    .then((response) => response.data)
    .catch((error) => {
      throw createApiError(error, "Erro ao remover link da loja.");
    });
}

export function atualizarLoja(formData) {
  return axios
    .put(`${API_URL}/lojas`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .catch((error) => {
      throw createApiError(error, "Erro ao atualizar a loja.");
    });
}

export function atualizarUsuario(userData) {
  return axios.put(`${API_URL}/user`, userData).catch((error) => {
    throw createApiError(error, "Erro ao atualizar usuário.");
  });
}

export function getTamanhoUploads() {
  return axios
    .get(`${API_URL}/user/uploads/tamanho`)
    .then((response) => response.data)
    .catch((error) => {
      throw createApiError(error, "Erro ao obter o tamanho dos uploads.");
    });
}

export function getAcoes() {
  return axios
    .get(`${API_URL}/analise/acoes`)
    .then((response) => response.data)
    .catch((error) => {
      throw createApiError(error, "Erro ao obter ações dos visitantes.");
    });
}

export function getVisitas() {
  return axios
    .get(`${API_URL}/analise/visitas`)
    .then((response) => response.data)
    .catch((error) => {
      throw createApiError(error, "Erro ao obter dados das visitas.");
    });
}

export function getPushOverview() {
  return axios
    .get(`${API_URL}/push/overview`)
    .then((response) => response.data)
    .catch((error) => {
      throw createApiError(error, "Erro ao obter notificações push.");
    });
}

export function criarPushCampaign(payload) {
  return axios
    .post(`${API_URL}/push/campaigns`, payload)
    .then((response) => response.data)
    .catch((error) => {
      throw createApiError(error, "Erro ao criar campanha push.");
    });
}

export function enviarPushCampaign(campaignId) {
  return axios
    .post(`${API_URL}/push/campaigns/${campaignId}/send`)
    .then((response) => response.data)
    .catch((error) => {
      throw createApiError(error, "Erro ao enviar campanha push.");
    });
}
